import React from 'react';
import { Header } from './components/Header';
import { MobileBottomBar } from './components/MobileBottomBar';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { RecentShipments } from './components/RecentShipments';
import { CtaBanner } from './components/CtaBanner';
import { HowItWorks } from './components/HowItWorks';
import { DealDirect } from './components/DealDirect';
import { Pricing } from './components/Pricing';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Services } from './components/Services';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen flex flex-col font-sans" data-id="element-0">
      <Header data-id="element-1" />

      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <TrustBar data-id="element-4" />
        <RecentShipments data-id="element-5" />
        <CtaBanner heading="Get a free, no-obligation RV transport quote in minutes" data-id="element-6" />
        <HowItWorks data-id="element-7" />
        <DealDirect data-id="element-8" />
        <Pricing data-id="element-9" />
        <CtaBanner heading="Ready for a fixed quote from a real RV hauler?" data-id="element-10" />
        <WhyChooseUs data-id="element-11" />
        <Services data-id="element-12" />
        <Testimonials data-id="element-13" />
        <FAQ data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>

      <Footer data-id="element-16" />
      <MobileBottomBar data-id="element-17" />
    </div>;
}